import {
  ExtractDocumentTypeFromTypedRxJsonSchema,
  RxCollection,
  RxDocument,
  RxJsonSchema,
  toTypedRxJsonSchema,
} from 'rxdb'

export const packSchemaLiteral = {
  title: 'Pack Schema',
  description: 'Describes a pack, which can include resources, text, etc.',
  version: 4,
  keyCompression: false,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 100,
    },
    title: {
      type: 'string',
    },
    version: {
      type: 'number',
    },
    user: {
      ref: 'users',
      type: 'string',
    },
    notes: {
      type: ['string', 'null'],
    },
    colour: {
      type: ['string', 'null'],
    },
    header: {
      ref: 'packHeaders',
      type: 'string',
    },
    footer: {
      ref: 'packFooters',
      type: 'string',
    },
    contents: {
      type: ['string', 'null'],
    },
    lastSent: {
      type: ['string', 'null'],
    },
    sendCount: {
      type: 'number',
    },
    quoteValue: {
      type: ['number', 'null'],
    },
    isPasswordProtected: {
      type: 'boolean',
    },
    defaultEmailSubject: {
      type: ['string', 'null'],
    },
    defaultEmailGreeting: {
      type: ['string', 'null'],
    },
    defaultEmailMessage: {
      type: ['string', 'null'],
    },
    defaultEmailLinkType: {
      type: ['string', 'null'],
    },
    defaultEmailLinkText: {
      type: ['string', 'null'],
    },
  },
  required: ['id', 'title', 'version', 'user'],
  indexes: [],
} as const

export const packMigrationStrategies = {
  1: (oldDoc: any) => ({
    ...oldDoc,
    lastSent: null,
    sendCount: 0,
  }),
  2: (oldDoc: any) => ({
    ...oldDoc,
    defaultEmailSubject: null,
    defaultEmailGreeting: null,
    defaultEmailMessage: null,
    defaultEmailLinkType: null,
    defaultEmailLinkText: null,
  }),
  3: (oldDoc: any) => ({
    ...oldDoc,
    isPasswordProtected: false,
  }),
  4: (oldDoc: any) => ({
    ...oldDoc,
    quoteValue: null,
  }),
}

const schemaTyped = toTypedRxJsonSchema(packSchemaLiteral)

export type PackDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>

export const packSchema: RxJsonSchema<PackDocType> = schemaTyped

export type PackDocMethods = {
  test: () => void
}

export const packDocMethods = {
  test: () => null,
}

export type PackDocument = RxDocument<PackDocType, PackDocMethods>

export type PackCollectionMethods = {
  test: () => void
}

export type PackCollection = RxCollection<PackDocType, PackDocMethods, PackCollectionMethods>
